<template>
  <v-dialog  v-model="dialog" persistent="persistent" max-width="600px">
    <v-card>
      <v-layout row align-center>
          <v-flex>
            <h1 class="title px-3">New Task</h1>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex shrink>
            <v-btn icon flat fab small @click="close()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      <v-card-text v-if="showDate.length !== 0">
        <v-layout row wrap>
          <v-flex xs12>
            <span>Due Date</span>
            <VueCtkDateTimePicker
              v-model="Task.dueDate"
              :min-date="minDate"
              :label="$t('labels.dueDate')"
              overlay="overlay"
            ></VueCtkDateTimePicker>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    ref="taskTitle"
                    :error-messages="titleErrors"
                    v-model="Task.title"
                    label="Title*"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap justify-space-between>
                    <v-flex v-if="showPriority.length !== 0">
                      <v-autocomplete
                        :items="comboBoxByID(2).ComboBoxDetails"
                        :label="$t('labels.priority')"
                        item-text="selector"
                        item-value="id"
                        v-model="Task.taskPriorityID"
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex v-if="showAssigned.length !== 0">
                      <v-autocomplete
                        v-model="Task.assignedToUserID"
                        :items="users"
                        item-text="fullName"
                        item-value="userID"
                        :label="$t('labels.assignedTo')"
                      ></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 v-if="showDescription.length !== 0">
                  <v-textarea
                    auto-grow="auto-grow"
                    v-model="Task.description"
                    :label="$t('labels.description')"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn-toggle class="elevation-0" v-model="showDescription" multiple>
          <v-tooltip class="ml-1 pointer" bottom="bottom">
            <template v-slot:activator="{ on }">
              <v-btn flat class="ml-0" v-on="on">
                <v-icon>mdi-note-outline</v-icon>
              </v-btn>
            </template>
            <span>Set Description</span>
          </v-tooltip>
        </v-btn-toggle>
        <v-btn-toggle class="elevation-0" v-model="showDate" multiple>
          <v-tooltip class="ml-1 pointer" bottom="bottom">
            <template v-slot:activator="{ on }">
              <v-btn flat class="ml-0" v-on="on">
                <v-icon>mdi-calendar-range</v-icon>
              </v-btn>
            </template>
            <span>Set Due Date</span>
          </v-tooltip>
        </v-btn-toggle>
        <v-btn-toggle class="elevation-0" v-model="showPriority" multiple>
          <v-tooltip class="ml-1 pointer" bottom="bottom">
            <template v-slot:activator="{ on }">
              <v-btn flat class="ml-0" v-on="on">
                <v-icon>mdi-priority-high</v-icon>
              </v-btn>
            </template>
            <span>Set Priority</span>
          </v-tooltip>
        </v-btn-toggle>

        <v-btn-toggle class="elevation-0" v-model="showAssigned" multiple>
          <v-tooltip class="ml-1 pointer" bottom="bottom">
            <template v-slot:activator="{ on }">
              <v-btn flat class="ml-0" v-on="on">
                <v-icon>mdi-account-multiple-plus-outline</v-icon>
              </v-btn>
            </template>
            <span>Assigne to someone else</span>
          </v-tooltip>
        </v-btn-toggle>
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="close()">Close</v-btn>
        <v-btn color="blue darken-1" :loading="loading" dark @click="save()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import locationService from "../../Location/service.js";
import taskService from "../service.js";
import userService from "../../User/service.js";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
const { validationMixin } = require("vuelidate");
const { required, minLength, email, minValue } = require("vuelidate/lib/validators");

export default {
  components: {
    VueCtkDateTimePicker
  },
  props: {
    createDialog: {
      default: false
    },
    createFromStore: {
      type: Boolean
    }
  },
  name: "create-task",
  data() {
    return {
      minDate: new Date().toISOString(),
      loading: false,
      dialog: false,
      users: [],
      Task: {
        title: null,
        description: null,
        taskPriorityID: 35,
        assignedToUserID: null,
        reporterUserID: null,
        dueDate: null
      },
      showDescription: [],
      showDate: [],
      showAssigned: [],
      showPriority: []
    };
  },
  mixins: [validationMixin],
  validations: {
    Task: {
      title: {
        required,
        minLength: minLength(4)
      }
    }
  },
  computed: {
    ...mapGetters("global", ["comboBox", "comboBoxByID", "currentUser"]),
    titleErrors() {
      const errors = [];
      if (!this.$v.Task.title.$dirty) return errors;
      if (!this.$v.Task.title.required) errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Task.title.minLength) errors.push("Field must be at least 4 characters long");
      return errors;
    }
  },
  watch: {
    createDialog(val) {
      if (val) {
        this.dialog = true;
        this.reset();
        this.getAllUsers();
        this.Task.assignedToUserID = this.currentUser.userID;
        this.Task.reporterUserID = this.currentUser.userID;
        this.$nextTick(() => {
          this.$refs.taskTitle.focus();
        });
      } else {
        this.dialog = false;
      }
    }
  },
  methods: {
    reset() {
      this.Task = {
        title: null,
        description: null,
        taskPriorityID: 35,
        assignedToUserID: this.currentUser.userID,
        reporterUserID: this.currentUser.userID,
        dueDate: null
      };
      this.showDescription = [];
      this.showDate = [];
      this.showAssigned = [];
      this.showPriority = [];
      this.$v.$reset();
    },
    getAllUsers() {
      return userService.getAllCrmUser().then(result => {
        this.users = result.data;
      });
    },
    getActiveStore() {
      return locationService.getAll({ list: "active" }).then(result => {
        result.data.map(row => {
          this.stores.push({
            id: row.storeID,
            name: row.Store.CSPID + " - " + row.Store.businessName
          });
        });
      });
    },
    close() {
      this.reset();
      this.$emit("close");
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          })
          .fire({
            type: "error",
            title: this.$t("toastMessage.text.invalidFields")
          });
      } else {
        this.loading = true;
        return taskService
          .create(this.Task)
          .then(result => {
            
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                })
                .fire({
                  type: "success",
                  title: "Task is created"
                });
              this.reset();
              this.loading = false;
              this.$emit("created");
              this.$events.fire("refresh-task-today");
              this.$events.fire("refresh-task");
              this.dialog = false;
            }
          })
          .catch(err => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              })
              .fire({
                type: "error",
                title: err.data.data
              });
          });
      }
    }
  }
};
</script>

<style scoped></style>
